import { gql } from '@apollo/client';
export const GET_REVIEW_FEEDBACK_SOURCES = gql `
  query GetReviewFeedbackSources($feedbackId: ID!) {
    feedbackSources(feedbackId: $feedbackId) {
      reasonForCitation
      quote
    }
  }
`;
export const GET_REDLINE_HIGHLIGHT = gql `
  query GetRedlineHighlight($html: String!, $quote: String!) {
    sourceRedlines(html: $html, quote: $quote) {
      path
      from
      to
    }
  }
`;
